/* eslint-disable @typescript-eslint/naming-convention */
import { createMuiTheme } from '@material-ui/core/styles';

import { palette } from './palette';
import { shadows } from './shadows';
import { spacing } from './spacing';
import { typography, fontSizes, fontWeights, fonts, lineHeights } from './typography';

declare module '@material-ui/core/styles/createBreakpoints' {
  interface BreakpointOverrides {
    xxs: true;
  }
}

type IFonts = {
  default: string;
};

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    /**
     * @deprecated This property should not be used anymore
     */
    radii: string[];
    /**
     * @deprecated This property should not be used anymore
     */
    borders: string[];
    /**
     * @deprecated This property should not be used anymore
     */
    fontSizes: typeof fontSizes;
    /**
     * @deprecated This property should not be used anymore
     */
    fontWeights: typeof fontWeights;
    /**
     * @deprecated This property should not be used anymore
     */
    lineHeights: typeof lineHeights;
    /**
     * @deprecated This property should not be used anymore
     */
    fonts: IFonts;
  }
  interface ThemeOptions {
    radii: string[];
    borders: string[];
    fontSizes: typeof fontSizes;
    fontWeights: typeof fontWeights;
    lineHeights: typeof lineHeights;
    fonts: IFonts;
  }
}

const radii = ['0px', '3px', '100px', '100%', '5px'];
const borders = ['0px', '1px', '2px', '3px'];

export const theme = createMuiTheme({
  shadows,
  palette,
  fonts,
  fontWeights,
  fontSizes,
  lineHeights,
  typography,
  spacing,
  breakpoints: {
    values: {
      xxs: 0,
      xs: 375,
      sm: 768,
      md: 1024,
      lg: 1440,
      xl: 1596,
    },
  },
  radii,
  borders,
});

export { fontSizes, fontWeights, lineHeights, radii, borders, fonts };
